export class TorchKpiOrghealthData {
  id: number;
  monthDate: Date;
  averageHeadcount: number;
  separationCount: number;
  turnoverRate: number;
}
